import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=520004a1&scoped=true&"
import script from "./Chart2.vue?vue&type=script&lang=js&"
export * from "./Chart2.vue?vue&type=script&lang=js&"
import style0 from "./Chart2.vue?vue&type=style&index=0&id=520004a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520004a1",
  null
  
)

export default component.exports